{
  "version": 1,
  "asset_id": "562ba066-b728-47d0-a043-1a1c2a1a7ae7",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/562ba066-b728-47d0-a043-1a1c2a1a7ae7/sleeve-excess-weight-loss-percentage-graph.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/562ba066-b728-47d0-a043-1a1c2a1a7ae7/sleeve-excess-weight-loss-percentage-graph.webp",
  "original_filename": "sleeve-excess-weight-loss-percentage-graph.webp",
  "size": 55294,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:29:04Z"
}
